import React from 'react';
import { Badge } from '../../components/ui';

const STATUS_CONFIG = {
  CONNECTED: { variant: 'success', label: 'Connected' },
  CONNECTING: { variant: 'warning', label: 'Connecting / Pairing' },
  DISCONNECTED: { variant: 'danger', label: 'Disconnected' },
};

const StatusBadge = ({ status }) => {
  const current = STATUS_CONFIG[status] || STATUS_CONFIG.DISCONNECTED;

  return (
    <Badge variant={current.variant} className="inline-flex items-center gap-1.5 px-2.5 py-1">
      <span className="relative flex h-2 w-2">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-current opacity-75" />
        <span className="relative inline-flex rounded-full h-2 w-2 bg-current" />
      </span>
      <span>{current.label}</span>
    </Badge>
  );
};

export default StatusBadge;